const SET_USERNAME = 'SET_USERNAME';
const SET_GUEST = 'SET_GUEST';
const LOGOUT = 'LOGOUT';

import { getField, updateField } from 'vuex-map-fields';
import UserService from '@/services/user.service';
import UserTempService from '@/services/temp.service';
import ImageService from '@/services/image.service';
import listenChannel from '@/util/socket';
import socketClient from '@/services/socket.service.js';
import moment from 'moment';

const SET_USER_INFO = 'SET_USER_INFO';
const SET_TRIAL_END_DATE = 'SET_TRIAL_END_DATE';
const SET_DETECTED_RESULTS = 'SET_DETECTED_RESULTS';
const RESET_USER_INFO = 'RESET_USER_INFO';

export default {
	namespaced: true,

	state() {
		return {
			username: null,
			guest: true,
			userId: null,
			trialEndDate: null,
			userInfo: {},
			detectedResults: {},
		};
	},

	actions: {
		async login({ dispatch }, payload) {
			const response = await UserService.login({
				user_name: payload.username,
				password: payload.password,
			});
			if (response.status == 200) {
				await dispatch('connectToChannel', payload.username);
			}
			return response;
		},

		async connectToChannel({ commit, dispatch, rootState }, payload) {
			commit(SET_USERNAME, payload);
			if (!payload.startsWith('guest')) commit(SET_GUEST, false);
			const updateModelCallback = (data) => {
				// call retrieveModels of trainer and detector
				dispatch('trainer/model/retrieveModels', data, { root: true });
				dispatch('detector/model/retrieveModels', data, { root: true });
				dispatch(
					'notification/retrieveAllNotification',
					{ username: rootState?.auth?.username },
					{ root: true }
				);
			};
			listenChannel(this._vm, payload, updateModelCallback, 'training');
		},

		async signup({ commit }, payload) {
			const response = await UserService.signup(payload);
			return response;
		},

		async removeUser({ commit }, payload) {
			const response = await UserService.removeUser(payload.userId);
			return response;
		},

		logout({ commit, state }) {
			socketClient.killChannel(state.username);
			localStorage.removeItem('token');
			commit(LOGOUT);
		},
		/**
		 * check validation of the user's token
		 * @param {object} param0: param
		 * @param {*} payload
		 */
		async validateToken({ commit, state }, payload) {
			await UserService.validateToken();
		},

		// USER INFORMATION
		async getUserInfo({ commit, dispatch }, userName) {
			try {
				let response = await UserTempService.getUserInfo(userName);
				if (response.status !== 200) {
					throw 'Get user info failed!';
				}

				let userInfo = {
					userName: response.data['username'],
					organization: response.data['organization'],
					email: response.data['email'],
					activeStatus: response.data['status'],
					id: response.data['_id']['$oid'],
					region: response.data['region'] || 'JA',
				};

				commit(SET_USER_INFO, userInfo);
				dispatch('setTrialEndDate', response.data['created_at']);

				dispatch('global/advancedSetting/getByUser', response.data['_id']['$oid'], {
					root: true,
				});
			} catch (error) {
				throw error;
			}
		},

		async getAllDetectedImageResults({ commit }, userName) {
			let params = {
				username: userName,
			};
			console.log('USER NAME', userName);
			try {
				let response = await ImageService.getAllDetectedResults(params);
				if (response.status !== 200) {
					throw 'Get results failed';
				}
				let detectedResults = {
					resultAmount: response.data['count_detected_images'],
					resultDetails: [
						response.data['count_ok_images'],
						response.data['count_ng_images'],
					],
				};
				commit(SET_DETECTED_RESULTS, detectedResults);
			} catch (error) {
				throw error;
			}
		},

		async updateUserInfo({ state }, newUserInfos) {
			let userId = state.userInfo['id'];
			try {
				let response = await UserTempService.updateUserInfo(userId, newUserInfos);
				if (response.status !== 200) {
					return false;
				}
				return true;
			} catch (error) {
				return false;
			}
		},

		setTrialEndDate({ commit }, createdDate) {
			let trialEndDate = moment(createdDate)
				.add(30, 'days')
				.format('YYYY/MM/DD HH:mm:ss');
			commit(SET_TRIAL_END_DATE, trialEndDate);
		},

		resetUserInfo({ commit, state }) {
			let emptyInfo = {
				userName: null,
				organization: null,
				email: null,
				activeStatus: null,
				id: null,
				region: null,
			};

			commit(RESET_USER_INFO, emptyInfo);
		},

		changePassword({ commit }, payload) {
			let response = UserService.changePassword({
				username: payload.username,
				old_password: payload.password.oldPassword,
				new_password: payload.password.newPassword,
			});
			return response;
		},

		async getUserList({ commit }, payload) {
			let response = await UserTempService.getUsernameList();
			return response.data;
		},
	},

	mutations: {
		updateField,

		SET_USERNAME(state, payload) {
			state.username = payload;
		},

		SET_GUEST(state, payload) {
			state.guest = payload;
		},

		LOGOUT(state) {
			state.username = null;
			state.guest = true;
		},

		SET_STATE(state, payload) {
			Object.entries(payload).forEach(([key, value]) => {
				state[key] = value;
			});
		},

		SET_USER_INFO(state, payload) {
			state.userInfo = payload;
		},

		SET_TRIAL_END_DATE(state, payload) {
			state.trialEndDate = payload;
		},

		SET_DETECTED_RESULTS(state, payload) {
			state.detectedResults = payload;
		},

		UPDATE_USER_INFO(state, payload) {
			state.userInfo = payload;
		},

		RESET_USER_INFO(state, payload) {
			state.userInfo = payload;
		},
	},

	getters: {
		getField,
	},
};
